module.exports = __webpack_public_path__ + "static/media/toggle1.a32ef1aa.png";